export default __webpack_public_path__ + "static/media/modal-close.9c422dbb.svg";